import http from "../http";

const UserService = {
    getUsersService: async () => {
        const users = await http.instance.get("/users");
        return users.data
    },
    getUserRolesService: async () => {
        const userRoles = await http.instance.get("/UserRoles/GetRoles");
        return userRoles.data
    },

    getPermissionsService: async () => {
        const permission = await http.instance.get("/Users/GetPermissions")
        return permission.data;
    },

    getUserPermissionsService: async (value) => {
        const userPernissions = await http.instance.get("/Users/UserPermissions", {params: {userId: value}})
        //console.log("Get User Permissions");
        //console.log(userPernissions.data);
        //console.log("Get User Permissions");
        return userPernissions.data;
    },

    setUserRoleService: async (form) => {
        const setUserRole = await http.instance.post("/Users/RoleUpdate", form)
        return setUserRole.data;
    },

    setUserActiveService: async (form) => {
        const setUserRole = await http.instance.post("/Users/UserActiveStatUpdate", form)
        return setUserRole.data;
    },

    setUserPermissionService: async (form) => {
        const setUserPermission = await http.instance.post("/UserRoles/AddUserPermission", form)
        return setUserPermission.data;
    }

};
export default UserService;
